import { render, staticRenderFns } from "./SiswaRegistrasi.vue?vue&type=template&id=9b36af04"
import script from "./SiswaRegistrasi.vue?vue&type=script&lang=js"
export * from "./SiswaRegistrasi.vue?vue&type=script&lang=js"
import style0 from "./SiswaRegistrasi.vue?vue&type=style&index=0&id=9b36af04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports